


















































import Vue from "vue"
import BoundaryLine from "~/components/guideline/util/BoundaryLine.vue"

export default Vue.extend({
  components: {
    BoundaryLine,
  },
})
